module.exports = __webpack_public_path__ + "assets/fonts/Alibaba-PuHuiTi-Medium.9c3c7ede.ttf";